import styled from "styled-components";
import { palette } from "styled-theme";

const SidebarWrapper = styled.div`
  display: flex;
  height: 100%;
  z-index: 3;
  .ant-layout-sider {
    background-color: ${palette("surfaceColor", 0)};
    box-shadow: ${(props) =>
      props["direction"] === "rtl"
        ? "-3px -18px 9px 2px rgba(0, 0, 0, 0.05)"
        : "3px 18px 9px 2px rgba(0, 0, 0, 0.05)"};
    height: calc(100vh - 64px);
  }
  .toggle {
    width: 100%;
    border-top: 1px solid ${palette("border", 0)};
    position: absolute;
    bottom: 0;
    height: 42px;
    display: flex;
    padding: 0 24px;
    align-items: center;
  }
  .ant-menu-submenu .ant-menu-sub .ant-menu-item {
    padding-right: 24px !important;
  }
`;

export default SidebarWrapper;
